export const NONE_OF_THE_ABOVE_OPTION = "None of the above";

const LEGACY_NONE_OPTION = "None";

export const toggleExclusiveNoneSelection = (
  selectedValues: string[],
  nextValue: string,
  noneValue: string = NONE_OF_THE_ABOVE_OPTION
): string[] => {
  if (nextValue === noneValue) {
    return [noneValue];
  }

  const filteredValues = selectedValues.filter(
    (value) => value !== noneValue && value !== LEGACY_NONE_OPTION
  );

  return filteredValues.includes(nextValue)
    ? filteredValues.filter((value) => value !== nextValue)
    : [...filteredValues, nextValue];
};

export const stripExclusiveNoneSelection = (
  values: string[],
  noneValue: string = NONE_OF_THE_ABOVE_OPTION
): string[] => values.filter((value) => value !== noneValue && value !== LEGACY_NONE_OPTION);